import { FC } from 'react';

import { SubBody } from '@rikstv/shared-components';

import styles from './TvGuideEmptyContainer.module.css';

export const TvGuideEmptyContainer: FC<{ channelName: string }> = ({ channelName }) => {
  return (
    <li className={styles.container}>
      <div className={styles.description}>
        <SubBody>Vi finner ikke informasjon om programmer for {channelName} på dette tidspunktet.</SubBody>
      </div>
    </li>
  );
};
